import { render, staticRenderFns } from "./PanelCompetitionRegisterForm.vue?vue&type=template&id=f5ae3c1c&scoped=true&"
import script from "./PanelCompetitionRegisterForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionRegisterForm.vue?vue&type=style&index=0&id=f5ae3c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ae3c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5ae3c1c')) {
      api.createRecord('f5ae3c1c', component.options)
    } else {
      api.reload('f5ae3c1c', component.options)
    }
    module.hot.accept("./PanelCompetitionRegisterForm.vue?vue&type=template&id=f5ae3c1c&scoped=true&", function () {
      api.rerender('f5ae3c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionRegisterForm.vue"
export default component.exports